export default __webpack_public_path__ + "static/media/map.526adb8b.png";